import { render, staticRenderFns } from "./VideoUploaderModal.vue?vue&type=template&id=68cf1366&"
import script from "./VideoUploaderModal.vue?vue&type=script&lang=js&"
export * from "./VideoUploaderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports